import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import { getSceneName } from "@/consts/consts.ts";
let Board = class Board extends Vue {
    constructor() {
        super(...arguments);
        this.cardsLocal = this.cards;
        this.selectedCards = Array();
        this.sceneName = "";
        this.To = {
            Bank: 2,
            Casino: 2,
            Hotel: 2,
            Apart: 4,
            Castle: 2,
            Last: 8
        };
    }
    mounted() {
        this.sceneName = getSceneName(this.cleared);
        if (this.sceneName === "すごろくボード") {
            this.sceneName = "スタート地点";
        }
    }
    selectCard(index) {
        if (this.selectedCards.includes(index)) {
            const i = this.selectedCards.findIndex(c => c == index);
            this.selectedCards.splice(i, 1);
        }
        else {
            this.selectedCards.push(index);
            this.selectedCards.sort((a, b) => a - b);
        }
    }
    validate() {
        let hosu = 0;
        this.selectedCards.forEach(c => (hosu += this.cardsLocal[c]["num"]));
        if (this.clearedCastle) {
            if (this.To.Last == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachLast();
            }
        }
        else if (this.clearedApart) {
            if (this.To.Castle == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachCastle();
            }
        }
        else if (this.clearedHotel) {
            if (this.To.Apart == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachApart();
            }
        }
        else if (this.clearedCasino) {
            if (this.To.Hotel == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachHotel();
            }
        }
        else if (this.clearedBank) {
            if (this.To.Casino == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachCasino();
            }
        }
        else {
            if (this.To.Bank == hosu) {
                this.selectedCards.forEach(c => (this.cardsLocal[c]["used"] = true));
                this.reachBank();
            }
        }
    }
};
__decorate([
    Prop()
], Board.prototype, "cards", void 0);
__decorate([
    Prop()
], Board.prototype, "reachBank", void 0);
__decorate([
    Prop()
], Board.prototype, "reachCasino", void 0);
__decorate([
    Prop()
], Board.prototype, "reachHotel", void 0);
__decorate([
    Prop()
], Board.prototype, "reachApart", void 0);
__decorate([
    Prop()
], Board.prototype, "reachCastle", void 0);
__decorate([
    Prop()
], Board.prototype, "reachLast", void 0);
__decorate([
    Prop()
], Board.prototype, "clearedBank", void 0);
__decorate([
    Prop()
], Board.prototype, "clearedCasino", void 0);
__decorate([
    Prop()
], Board.prototype, "clearedHotel", void 0);
__decorate([
    Prop()
], Board.prototype, "clearedApart", void 0);
__decorate([
    Prop()
], Board.prototype, "clearedCastle", void 0);
__decorate([
    Prop()
], Board.prototype, "cleared", void 0);
__decorate([
    Prop()
], Board.prototype, "player", void 0);
Board = __decorate([
    Component
], Board);
export default Board;
